(() => {
  const shop = document.currentScript?.dataset.fourpawShop || "";
  if (!/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/i.test(shop)) return;

  // The legacy Shopify loader runs on window load. Let it register its script
  // first; unpublished previews can omit it even with native Loox blocks.
  const ensureLoox = () => {
    if (!document.querySelector('.loox-rating, #looxReviews, #looxReviewsFrame, .loox-reviews-default')) return;
    if (document.querySelector('script[src*="loox.io/widget/"]')) return;
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://loox.io/widget/loox.js?shop=${encodeURIComponent(shop)}`;
    script.dataset.fourpawLooxLoader = "true";
    document.head.appendChild(script);
  };

  if (document.readyState === "complete") ensureLoox();
  else window.addEventListener("load", ensureLoox, { once: true });
})();
